/* tslint:disable */

/**
 */
export class EInvoiceView {
    data?: string;
}
